import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { IAddressData } from '@df/session/api/address-book/address';

@Component({
    selector: 'account-address-body',
    templateUrl: './account-address-body.html',
    standalone: true,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class AccountAddressBodyComponent {
    @Input()
    addressData?: IAddressData;

    private isAddressData = (addressData: IAddressData | undefined): addressData is IAddressData => !!addressData;

    get lines() {
        if (!this.addressData) {
            return [];
        }
        return [['street_1'], ['street_2', 'street_3'], ['city'], ['postcode']]
            .map(fields => fields.map(field => (this.addressData ? this.addressData[field] : undefined)).filter(this.isAddressData))
            .filter(i => i.length);
    }

    get telephone(): string | undefined {
        return this.addressData?.telephone;
    }
}
